import React, { useState, useEffect } from 'react';
import { useParams } from "react-router";
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Dialog } from 'primereact/dialog';
import { Chip } from 'primereact/chip';
import { Button } from 'primereact/button';
import Menu from '../../components/sturtural/Menu';
import Loader from '../../components/sturtural/Loader';
import { useNavigate } from 'react-router-dom';

import MessageDetail from '../../components/sturtural/MessageDetail';
import { storage } from '../../helpers/storage';

const ResumenTabletas = () => {

    const [message, setMessage] = useState(false);
    const [alumno, setAlumno] = useState(null);
    const [prendas, setPrendas] = useState(null);
    const [loading, setLoading] = useState(true);

    const [frontal, setFrontal] = useState(null);
    const [reverso, setReverso] = useState(null);
    const [firma, setFirma] = useState(null);
    const [comprobante, setComprobante] = useState(null);
    const navigate = useNavigate()

    let { q } = useParams();
    const ciclo = storage.get('ciclo');

    useEffect(() => {
        if (isNormalInteger(q)) {
            setLoading(true);
            helpHttp().post(`${BASE_API}DetalleEntrega/ObtenerDetalleEntrega/${q}?IdCicloEscolar=${ciclo.IdCicloEscolar}`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                console.log(res)
                if (!res.err) {
                    if (parseInt(res.IdAlumno) === parseInt(q)) {
                        setAlumno(res);
                        setPrendas(res.PrendasActivas);

                        getImagen(res.IdDocFrontal).then(x => setFrontal(x));
                        getImagen(res.IdDocReverzo).then(x => setReverso(x));
                        getImagen(res.IdDocFirma).then(x => setFirma(x));

                        if (res.IdComprobante > 0) {
                            getImagen(res.IdComprobante).then(x => setComprobante(x));
                        }
                    } else {
                        setAlumno(null);
                    }
                } else {
                    setAlumno(null)
                }
                setLoading(false);
            });
        } else {
            setMessage("Faltan parametros importantes para realizar este proceso");
        }
    }, [q]);

    const getImagen = (IdDoc) => {
        let imagen = helpHttp().post(`${BASE_API}DetalleEntrega/ObtenerImagen/${IdDoc}`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        })
        return imagen;
    }

    const isNormalInteger = (str) => {
        let n = ~~Number(str);
        return String(n) === str && n >= 0;
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => setMessage(false)} icon="pi pi-check" className="p-button-secondary" />;

    const isMobile = () => {
        return (
            (navigator.userAgent.match(/Android/i)) ||
            (navigator.userAgent.match(/webOS/i)) ||
            (navigator.userAgent.match(/iPhone/i)) ||
            (navigator.userAgent.match(/iPod/i)) ||
            (navigator.userAgent.match(/iPad/i)) ||
            (navigator.userAgent.match(/BlackBerry/i))
        );
    }

    return (
        <>
            <Menu link='nueva-solicitud' />
            {isMobile() &&
                <div className="col-12">
                    <div className="card">
                        <div className="surface-border pt-3 flex">
                            <button type="button" aria-label="Filtro" className="p-button p-component p-button-outlined w-6 mr-2" onClick={() => navigate("/filtro-alumno/na")}>
                                <span className="p-button-label p-c"><i className='pi pi-search'></i> Filtro</span><span role="presentation" className="p-ink"></span>
                            </button>
                            <button type='submit' aria-label="Pendientes" name="button-data" id="button-data" className="p-button p-component w-6 ml-2" onClick={() => navigate("/pendientes-alumno")}>
                                <span className="p-button-label p-c"><i className='pi pi-search'></i> Pendientes</span><span role="presentation" className="p-ink"></span>
                            </button>
                        </div>
                    </div>
                </div>}

            {(loading
                ?
                <div><Loader /></div>
                :
                (alumno != null
                    ?
                    <>
                        <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
                            <div className="mb-3 font-bold text-2xl">
                                <span className="text-900">{alumno.NombreAlumno}</span>
                            </div>
                            <div className="mb-3 font-bold text-2xl">
                                <span className="text-700">Tutor: {alumno.NombreTutor}</span>
                            </div>
                            <div className="font-bold mb-1">
                                <span className="text-blue-600">Entregado: {alumno.Fecha}</span>
                            </div>

                            <div className="text-700 text-sm mb-6">
                                {prendas && prendas.map((el, index) =>
                                    <Chip label={`${el.Prenda}: ${el.Talla}`} className="mr-2 mb-2" key={index} />
                                )}
                            </div>

                            <div className="">
                                Usuario: {alumno.NombreUsuario} Escuela: {alumno.NombreTienda}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="col-12 p-3">
                                <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                                    <div className="p-4">
                                        <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                            <i className={`pi pi-images text-xl text-gray-600`}></i>
                                        </span>
                                        <span className="text-900 font-medium text-2xl">
                                            CAPTURA FRONTAL DE IDENTIFICACIÓN
                                        </span>
                                    </div>

                                    <div className='col-12'>
                                        <img
                                            style={{ 'display': 'block', 'width': '100%', 'height': '100%' }}
                                            id='base64image'
                                            src={frontal}>
                                        </img>
                                    </div>

                                    <div className="px-4 py-3 surface-100 text-right">
                                        <div className="input-group">

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 p-3">
                                <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                                    <div className="p-4">
                                        <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                            <i className={`pi pi-images text-xl text-gray-600`}></i>
                                        </span>
                                        <span className="text-900 font-medium text-2xl">
                                            CAPTURA REVERSO DE IDENTIFICACIÓN
                                        </span>
                                    </div>

                                    <div className='col-12'>
                                        <img
                                            style={{ 'display': 'block', 'width': '100%', 'height': '100%' }}
                                            id='base64image'
                                            src={reverso}>
                                        </img>
                                    </div>

                                    <div className="px-4 py-3 surface-100 text-right">
                                        <div className="input-group">

                                        </div>
                                    </div>
                                </div>
                            </div>

                            {comprobante &&
                                <div className="col-12 p-3">
                                    <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                                        <div className="p-4">
                                            <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                                <i className={`pi pi-images text-xl text-gray-600`}></i>
                                            </span>
                                            <span className="text-900 font-medium text-2xl">
                                                CAPTURA COMPROBANTE
                                            </span>
                                        </div>

                                        <div className='col-12'>
                                            <img
                                                style={{ 'display': 'block', 'width': '100%', 'height': '100%' }}
                                                id='base64image'
                                                src={comprobante}>
                                            </img>
                                        </div>

                                        <div className="px-4 py-3 surface-100 text-right">
                                            <div className="input-group">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="col-12 p-3">
                                <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                                    <div className="p-4">
                                        <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                            <i className={`pi pi-images text-xl text-gray-600`}></i>
                                        </span>
                                        <span className="text-900 font-medium text-2xl">
                                            FIRMA DIGITAL
                                        </span>
                                    </div>

                                    <div className='col-12'>
                                        <img
                                            style={{ 'display': 'block', 'width': '100%', 'height': '100%' }}
                                            id='base64image'
                                            src={firma}>
                                        </img>
                                    </div>

                                    <div className="px-4 py-3 surface-100 text-right">
                                        <div className="input-group">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <MessageDetail color="warn" mensaje="No se encontró la informacion requerida" />
                )

            )}

            <Dialog header="Aviso" visible={message} onHide={() => setMessage(false)} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default ResumenTabletas;